<template>
	<div class="card-item-box">
		<div class="overview-wrap">
			<CardItemWrapper
				class="overview-item"
				v-for="(item, index) in List"
				:key="index"
				@more="handlePreview(item)"
			>
				<div class="report-box-item">
					<div class="file-icon">
						<SvgIcons :fileUrl="item.url" isFile class="icon" />
					</div>

					<div class="report-wrapper">
						<div class="report-wrapper-title text-overflow">
							{{ item.title }}
						</div>
						<div class="report-wrapper-footer">
							<div :class="`type ${item.typeClass}`" v-if="item.typeText">
								{{ item.typeText }}
							</div>
							<p class="time">{{ item.time }}</p>
						</div>
					</div>
				</div>
			</CardItemWrapper>
		</div>
	</div>
</template>

<script setup>
import CardItemWrapper from './card-item-wrapper.vue';
defineProps({
	List: {
		type: Array,
		default: () => []
	}
});

const emit = defineEmits(['handlePreview']);

const handlePreview = info => {
	emit('handlePreview', info);
};
</script>

<style lang="less" scoped>
.overview-wrap {
	display: flex;
	flex-flow: row wrap;

	.overview-item {
		width: calc(50% - 8px);
		&:nth-child(2n) {
			margin-left: 16px;
		}

		margin-top: 12px;

		&:nth-child(-n + 2) {
			margin-top: 0;
		}

		.report-box-item {
			display: flex;
			height: 50px;

			.file-icon {
				display: flex;
				align-items: center; // 垂直居中
				.icon {
					width: 36px;
					height: 36px;
				}
			}

			.report-wrapper {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				overflow: hidden;
				margin-left: 10px;

				&-title {
					color: #1d2129;
					text-align: justify;

					font-size: 16px;

					font-weight: 500;
					line-height: 24px; /* 150% */
				}
				&-footer {
					display: flex;
					.type {
						display: flex;
						align-items: center;
						justify-content: center;
						padding: 0 4px;
						font-size: 10px;
						font-weight: 500;
						line-height: 19px;
						margin-right: 12px;

						color: var(--t-secondary-color, #4e5969);
						background: var(--fill-normal-color, #f2f3f5);
					}

					.time {
						color: var(--t-secondary-color, #4e5969);

						font-size: 14px;
					}

					// 颜色样式类名
					.rating-1 {
						color: var(---, #f23d3d);
						background: var(
							---,
							linear-gradient(0deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.9) 100%),
							#f23d3d
						);
					}
					.rating-2 {
						color: var(---, #30bf54);
						background: var(
							---,
							linear-gradient(0deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.9) 100%),
							#36d95f
						);
					}
					.rating-3 {
						color: var(---, #3964e5);
						background: linear-gradient(0deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.9) 100%),
							#3964e5;
					}

					.rating-4 {
						color: var(--t-secondary-info-color, #86909c);
						background: var(--fill-normal-color, #f2f3f5);
					}
				}
			}
		}
	}
}
</style>
